module.exports = __webpack_public_path__ + "static/media/attachments-icon.0dd0e375.svg";